import { LayerEntity } from '../entities/layer-entity';

export class LayerValueObject {
  constructor(
    public readonly baseMapLayer: string,
    public readonly operationalLayers: LayerEntity[],
  ) {}
}
